// @flow
import types from "./types";
import type {Action} from "../DucksUtils";
import type {ServerRideStatusType} from "../../../Utils/AppUtils";
import type {PickupDropoff} from "../CurrentProposal/reducers";
import CurrentProposalTypes from "../CurrentProposal/types";

export type VehicleDetails = {
    identifier: string,
    number: string,
    driver_phone_number: string,
    driver_name: string,
}

export type WalkingMap = {
    pending: boolean,
    legsLatLngs?: Array<Object>, //TODO(Oded): write a better type here
}

type MandatoryKeys = {|
    ride_id: string,
    acceptedTimestamp: number,
    vehicle_details: VehicleDetails,
    dropoff_location: PickupDropoff,
    eta: number,
    eta_description: string,
    ride_status: ServerRideStatusType,
    pickup_location: PickupDropoff,
|}
type OptionalKeys = {|
    walkingMap?: WalkingMap,
    awaitingDriverApproval?: boolean,
    driver_phone?: string,
|}
export const CurrentRideDefault = Object.freeze({});
export type CurrentRide = { ...MandatoryKeys, ...OptionalKeys } | OptionalKeys;

const CurrentRideReducer = (currentRide: CurrentRide = CurrentRideDefault, action: Action): CurrentRide => {
    const type: string = action.type;
    const payload = action.payload;
    switch (type) {
        case types.RIDE_DATA_UPDATE:
            return {
                ...currentRide,
                ...payload,
            };
        case CurrentProposalTypes.PROPOSAL_DATA_CLEAR:
        case types.RIDE_DATA_CLEAR:
            return Object.freeze({});
        case types.RIDE_WALKINGMAP_REQUEST:
            return {
                ...currentRide,
                walkingMap: {
                    pending: true,
                },
            };
        case types.RIDE_WALKINGMAP_UPDATE:
            return {
                ...currentRide,
                walkingMap: {
                    pending: false,
                    ...payload,
                },
            };
        case types.RIDE_DRIVER_PHONE:
            return {
                ...currentRide,
                driver_phone: payload,
            };
        default:
            return currentRide;

    }
};

export default CurrentRideReducer;


// WEBPACK FOOTER //
// ./src/Store/Ducks/CurrentRide/reducers.js